import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container,  ContentWithPaddingXlA } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
// import Header from "components/headers/light.js";


const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Formation Devops" }) => {
  return (
    <AnimationRevealPage>
     
      <Container>
        <ContentWithPaddingXlA>
          
          <Text>
            {/* <p>Derniere mise a jour: Mardi 14 février 2023</p> */}

            {/* <p>
            lorem ipsum dolor sit amet consectetur adipiscing elit
            </p>

            <p>
            lorem ipsum dolor sit amet consectetur adipiscing elit
            </p> */}

            <h1>LES FONCTIONNALITÉS PRINCIPALES</h1>
            
            <ul>
              <li>
                <p>
                Gestion des déclarations 
                  (Encaissement & 
                  Passer en impayé) 
                </p>
              </li>
              <li>
                <p>
                  Formalités d’enregistrement
                </p>
              </li>
              <li>
                Gestion des prises en charges (Recouvrement Amiable & Recouvrement Forcé)
              </li>
              <li>
                Encaissement
              </li>
              <li>
                Gestion compte débiteur

              </li>{" "}
              <li>
                Suivi du recouvrement par voie d’huissier

              </li>
              <li>
                 Pilotages des activités du recouvrement (Gestion des délais & Gestion des objectifs LFI, LFR sur prise en charge)
              </li>
              <li>
                Assistance recouvrement
                (Gestion de la demande d’assistance au recouvrement à un état tiers & 
                  Gestion de l’assistance au recouvrement à un état tiers & 
                  Développer le module contribuable & 
                  Développer le portail contribuable pour la télé déclaration et le télépaiement )
              </li>
              <li>
                Comptabilité 
                (Comptabilité journalière & 
                Comptabilité mensuelle & 
                Tableau des Opération Financières de l’état (TOFE) )
              </li>
             
              
              
            </ul>  

          </Text>
        </ContentWithPaddingXlA>
      </Container>
     
    </AnimationRevealPage>
  );
};
